import {pageViewIdParamName} from '../data-layer-client/buildDataLayerFrame';
import {getSearchParams} from '../utils/searchParams/getSearchParams';

export function getPageViewId(): string | undefined {
  const searchParams = getSearchParams();
  return searchParams.get(pageViewIdParamName) ?? undefined;
}
